<template>
    <div class="columns">
        <div class="column">
            <h2> Register </h2>
            <div>
                <label>Name</label>
                <div>
                    <div :class="{ error: errors.has('first_name') }">
                        <input type="text" class="input" name="first_name" placeholder="First Name" v-model="first_name"
                           v-validate="{ required: true }" data-vv-as="first name">
                        <p v-if="errors.has('first_name')">{{errors.first('first_name')}}</p>
                    </div>
                    <br>
                    <div :class="{ error: errors.has('last_name') }">
                        <input type="text" class="input" name="last_name" placeholder="Last Name" v-model="last_name"
                           v-validate="{ required: true }" data-vv-as="last name">
                        <p v-if="errors.has('last_name')">{{errors.first('last_name')}}</p>
                    </div>
                </div>
            </div>
            <br>

            <div :class="{ error: errors.has('email') }">
                <label>Email</label>
                <div :class="{ 'left icon loading': emailLoading }">
                    <i class="search icon" v-if="emailLoading"></i>
                    <input type="email" class="input" placeholder="emailaddress@mail.com" name="email" v-model.lazy.trim="email"
		                     v-validate="{ required: true, email: true, emailAvailable: true }">
		          </div>
                    <p v-if="errors.has('email')">{{errors.first('email')}}</p>
                </div>
                <br>

                <div :class="{ error: errors.has('password') }">
                    <label>Password</label>
                    <input type="password" class="input" placeholder="Password" name="password" v-model="password"
                   v-validate="{ required: true }">
                    <p v-if="errors.has('password')">{{errors.first('password')}}</p>
                </div>
                <br>

                <div :class="{ error: errors.has('password_conf') }">
                    <label>Password Confirmation</label>
                    <input type="password" class="input" placeholder="Password Confirmation" name="password_conf" v-model="password_conf"
                   v-validate="{ required: true, confirmed: password}" data-vv-as="password confirmation">
                    <p v-if="errors.has('password_conf')">{{errors.first('password_conf')}}</p>
                </div>
                <br>

                <button type="button" class="button" @click="register">Register</button>
            </div>
        </div>
</template>

<style scoped>
h2 {
  margin-bottom: 10%;
  text-align: center;
}

.columns {
  max-width: 800px;
  margin: auto;
  padding: 0% 5% 0% 5%;
}
</style>

<script>
export default {
  name: 'Register',

  data() {
    return {
      emailLoading: false,

      first_name: '',
      last_name: '',
      email: '',
      password: '',
      password_conf: '',
    };
  },

  methods: {
    register() {
      this.$validator.validateAll();

      if (!this.errors.any()) {
        this.$store
          .dispatch('auth/register', {
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            password: this.password,
            password_conf: this.password_conf,
          })
          .then(() => this.$router.replace('/'));
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/auth/Register.vue